import { render, staticRenderFns } from "./GDCalcWidget.vue?vue&type=template&id=5f9c2df0&"
import script from "./GDCalcWidget.vue?vue&type=script&lang=js&"
export * from "./GDCalcWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports